import { render, staticRenderFns } from "./Rotating-picture.vue?vue&type=template&id=1045f18a&scoped=true"
import script from "./Rotating-picture.vue?vue&type=script&lang=js"
export * from "./Rotating-picture.vue?vue&type=script&lang=js"
import style0 from "./Rotating-picture.vue?vue&type=style&index=0&id=1045f18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045f18a",
  null
  
)

export default component.exports